import { createEndpoint, createEndpointWithPagination } from "../createEndpoint";
import type { HttpClient, QueryParams } from "../httpClient";
import {
    AdminExpertClaimResponseSchema,
    AdminExpertClaimSchema,
    ApproveExpertClaimResponseSchema,
    type AdminDecideExpertClaimRequest,
    type AdminExpertClaim,
    type AdminExpertClaimResponse,
    type AdminExpertClaimsListQueryParams,
    type AdminUpdateExpertClaimNoteRequest,
    type AdminUpdateExpertClaimRequest,
    type ApproveExpertClaimResponse,
} from "../schemas/expert-claims";

export function createAdminExpertClaimsApi(http: HttpClient, baseUrl: string) {
    const adminBaseUrl = `${baseUrl}/admin/expert-claims`;

    return {
        list: createEndpointWithPagination<
            AdminExpertClaim,
            unknown,
            unknown,
            AdminExpertClaimsListQueryParams
        >(http, "GET", "", {
            base: adminBaseUrl,
            itemSchema: AdminExpertClaimSchema,
        }),

        get: createEndpoint<
            AdminExpertClaimResponse,
            unknown,
            QueryParams,
            { claimId: number | string }
        >(http, "GET", "/:claimId", {
            base: adminBaseUrl,
            responseSchema: AdminExpertClaimResponseSchema,
            params: ["claimId"],
        }),

        update: createEndpoint<
            AdminExpertClaimResponse,
            AdminUpdateExpertClaimRequest,
            QueryParams,
            { claimId: number | string }
        >(http, "PUT", "/:claimId", {
            base: adminBaseUrl,
            responseSchema: AdminExpertClaimResponseSchema,
            params: ["claimId"],
        }),

        updateNote: createEndpoint<
            AdminExpertClaimResponse,
            AdminUpdateExpertClaimNoteRequest,
            QueryParams,
            { claimId: number | string }
        >(http, "PUT", "/:claimId/note", {
            base: adminBaseUrl,
            responseSchema: AdminExpertClaimResponseSchema,
            params: ["claimId"],
        }),

        approve: createEndpoint<
            ApproveExpertClaimResponse,
            AdminDecideExpertClaimRequest,
            QueryParams,
            { claimId: number | string }
        >(http, "POST", "/:claimId/approve", {
            base: adminBaseUrl,
            responseSchema: ApproveExpertClaimResponseSchema,
            params: ["claimId"],
        }),

        reject: createEndpoint<
            AdminExpertClaimResponse,
            AdminDecideExpertClaimRequest,
            QueryParams,
            { claimId: number | string }
        >(http, "POST", "/:claimId/reject", {
            base: adminBaseUrl,
            responseSchema: AdminExpertClaimResponseSchema,
            params: ["claimId"],
        }),

        cancelDecision: createEndpoint<
            AdminExpertClaimResponse,
            unknown,
            QueryParams,
            { claimId: number | string }
        >(http, "POST", "/:claimId/cancel-decision", {
            base: adminBaseUrl,
            responseSchema: AdminExpertClaimResponseSchema,
            params: ["claimId"],
        }),
    };
}

export type AdminExpertClaimsApi = ReturnType<typeof createAdminExpertClaimsApi>;
